import { formatLanguages, formatShelterListAddress, useRouter } from '@application/utils';
import type { ShelterGetSheltersQuery, ShelterListGetSheltersQuery } from '@gql/graphql';
import type { CardItemShelterData } from '@presentation/components';
import { PLACEHOLDER_IMAGE_SHELTER } from '@presentation/constants';
import { useMemo } from 'react';

export const useFormatShelters = (
  shelters?:
    | ShelterListGetSheltersQuery['findManyDogShelter']
    | ShelterGetSheltersQuery['findManyDogShelter']
    | null,
) => {
  const { language, routeLocationDescriptor, translate } = useRouter();

  const formattedShelters: CardItemShelterData[] | undefined = useMemo(() => {
    if (!shelters || !shelters.length) return;

    return shelters.map((shelter) => {
      const url =
        shelter.translations?.find((tr) => tr.language === language)?.url ??
        shelter.translations[0]?.url;
      return {
        id: shelter.id,
        name: shelter.name,
        image: shelter.imgs[0]?.small ?? PLACEHOLDER_IMAGE_SHELTER,
        location: formatShelterListAddress(translate, { ...shelter.address }),
        languages: formatLanguages(language, shelter.spokenLanguages),
        link: url
          ? routeLocationDescriptor('shelter', {
              params: [url],
            })
          : routeLocationDescriptor('shelterList'),
      };
    }) as CardItemShelterData[];
  }, [language, routeLocationDescriptor, shelters, translate]);

  return { formattedShelters };
};
